module.exports = __webpack_public_path__ + "img/logo_name.0fe54f6a.png";